import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { useMemo } from "react";
import { Box, Flex, Text } from "sprout-ui-primitives";
import { CardContent, CardLink } from "@sprout/client-components/dist/Card";
import { colorMap } from "@sprout/client-lib/dist/labels_next";
import { Close, LocalOfferTwoTone } from "sprout-ui-icons";
import { Button } from "sprout-ui-dom/dist/Button";
const StyledBox = styled(Box)`
  position: relative;
`;
const StyledLocalOfferTwoTone = styled(LocalOfferTwoTone)`
  width: 18px;
  height: 18px;
`;
const StyledButton = styled(Button)`
  width: 24px;
  height: 24px;
  margin-right: -8px;
  margin-left: 4px;
`;
const StyledClose = styled(Close)`
  width: 18px;
  height: 18px;
`;
const PostPageLabelsLabel = (props)=>{
    const { label , rootURL , onClick  } = props;
    const { style , text  } = label;
    const handleClick = useMemo(()=>{
        if (!onClick) return undefined;
        return ()=>{
            onClick(label);
        };
    }, [
        label,
        onClick
    ]);
    return /*#__PURE__*/ _jsxs(StyledBox, {
        px: 2,
        borderRadius: "30px",
        bg: colorMap[style],
        color: "white.100",
        children: [
            /*#__PURE__*/ _jsx(CardLink, {
                to: `${rootURL}/label/${label.id}`
            }),
            /*#__PURE__*/ _jsxs(CardContent, {
                as: Flex,
                minHeight: "32px",
                py: 0,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(StyledLocalOfferTwoTone, {}),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        ml: 0,
                        fontWeight: "medium",
                        children: text
                    }),
                    handleClick && /*#__PURE__*/ _jsx(StyledButton, {
                        onClick: handleClick,
                        color: "white.100",
                        variant: "circle-bright-blue-bg",
                        children: /*#__PURE__*/ _jsx(StyledClose, {})
                    })
                ]
            })
        ]
    });
};
export default PostPageLabelsLabel;
